import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { DateTimePickerApi } from '../../Widgets/DateTimePicker';
import { Utils } from '../../Utils/Utils';
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';
import { StatusMessage, StatusMessageModel, StatusMessageType } from '../../Widgets/StatusMessage'
import { DateUtils } from '../../Utils/DateUtils';

export interface BrowserPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    urlBonusDetail: string;
    urlCustomerDetail: string;
    urlCustomerOperationDetail: string;
    urlPlayerDetail: string;
    urlCount: string;
    urlExport: string;
    urlExportAll: string;
}

var FILTER_DELIM = '-delim-';
const checkboxName = 'selectedTicketId';
const batchSize = 100;

class ProgressiveBonusBrowseRequest {
    public TicketId: string;
    public Status: string;
    public Handpay: string;
    public Bonus: string;
    public Player: string;
    public Customer: string;
    public CustomerOperation: string;
    public LevelWon: string;
    public CreatedFrom: number | null;
    public CreatedTo: number | null;
    public StartedFrom: number | null;
    public StartedTo: number | null;
    public FinishedFrom: number | null;
    public FinishedTo: number | null;
    public PaidCanceledFrom: number | null;
    public PaidCanceledTo: number | null;
    public Result: string;
    public Source: string;
    public LastTicketId: string;
    public LastFinished: string;
    public BatchSize: number;
}

export class IndexPage {
    private _options: BrowserPageOptions;
    private _runButton: JQuery;
    private _loadMoreButton: JQuery;
    private _resetFilterButton: JQuery;
    private _currentRequest: ProgressiveBonusBrowseRequest;
    private _exportButton: JQuery;
    private _exportAllButton: JQuery;

    private _filterTicketId: JQuery;
    private _filterStatus: MultiSelectApi;
    private _filterHandPay: MultiSelectApi;
    private _filterBonus: MultiSelectApi;
    private _filterPlayer: JQuery;
    private _filterCustomer: MultiSelectApi;
    private _filterCustomerOperation: MultiSelectApi;
    private _filterLevelWon: MultiSelectApi;
    private _filterCreatedFrom: DateTimePickerApi;
    private _filterCreatedTo: DateTimePickerApi;
    private _filterStartedFrom: DateTimePickerApi;
    private _filterStartedTo: DateTimePickerApi;
    private _filterFinishedFrom: DateTimePickerApi;
    private _filterFinishedTo: DateTimePickerApi;
    private _filterPaidCanceledFrom: DateTimePickerApi;
    private _filterPaidCanceledTo: DateTimePickerApi;
    private _filterResult: MultiSelectApi;

    private _source: JQuery;
    private _btnCountResult: JQuery;
    private _totalEntries: JQuery;
    private _checkAll: JQuery;
    private _processing: JQuery;

    constructor(options: BrowserPageOptions) {
        this.run = this.run.bind(this);
        this.loadMore = this.loadMore.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
        this.getCountResult = this.getCountResult.bind(this);
        this.showLoadMoreButton = this.showLoadMoreButton.bind(this);
        this.hideLoadMoreButton = this.hideLoadMoreButton.bind(this);
        this.enableRunButton = this.enableRunButton.bind(this);
        this.checkBoxAll = this.checkBoxAll.bind(this);
        this._options = options;
        this._filterTicketId = Utils.getJQueryById("filterTicketId");
        this._filterPlayer = Utils.getJQueryById("filterPlayer");
        this._filterStatus = new MultiSelectApi("filterStatus");
        this._filterHandPay = new MultiSelectApi("filterHandpay");
        this._filterBonus = new MultiSelectApi("filterBonus");
        this._filterCustomer = new MultiSelectApi("filterCustomer");
        this._filterCustomerOperation = new MultiSelectApi("filterCustomerOperation");
        this._filterLevelWon = new MultiSelectApi("filterLevel");
        this._filterResult = new MultiSelectApi("filterResult");

        this._filterStartedFrom = new DateTimePickerApi("filterStartedFrom");
        this._filterStartedTo = new DateTimePickerApi("filterStartedTo");
        this._filterFinishedFrom = new DateTimePickerApi("filterFinishedFrom");
        this._filterFinishedTo = new DateTimePickerApi("filterFinishedTo");
        this._filterCreatedFrom = new DateTimePickerApi("filterCreatedFrom");
        this._filterCreatedTo = new DateTimePickerApi("filterCreatedTo");
        this._filterPaidCanceledFrom = new DateTimePickerApi("filterPaidCanceledFrom");
        this._filterPaidCanceledTo = new DateTimePickerApi("filterPaidCanceledTo");

        this._source = Utils.getJQueryById("source");

        this._runButton = Utils.getJQueryById("btnRunQuery");
        this._runButton.on("click", this.run);

        this._loadMoreButton = Utils.getJQueryById("btnLoadMore");
        this._loadMoreButton.on("click", this.loadMore);

        this._resetFilterButton = Utils.getJQueryById("btnResetFilter");
        this._resetFilterButton.on("click", this.resetFilter);

        this._btnCountResult = Utils.getJQueryById("btnCountResult");
        this._btnCountResult.on("click", this.getCountResult);

        this._totalEntries = Utils.getJQueryById("totalEntries");

        this._checkAll = Utils.getJQueryById("selectAll");
        this._checkAll.on("change", this.checkBoxAll);

        this._processing = Utils.getJQueryById("processing");
    }

    private sendRequest(request: ProgressiveBonusBrowseRequest) {
        let urlList = this._options.urlList;
        let urlDetail = this._options.urlDetail;
        let urlBonusDetail = this._options.urlBonusDetail;
        let urlPlayerDetail = this._options.urlPlayerDetail;
        let urlCustomerDetail = this._options.urlCustomerDetail;
        let urlCustomerOperationDetail = this._options.urlCustomerOperationDetail;
        let table = this.getTableBody();
        let getDetailUrl = this.getDetailUrl;
        let showLoadMore = this.showLoadMoreButton;
        let hideLoadMore = this.hideLoadMoreButton;
        let enableRunButton = this.enableRunButton;
        let processing = this._processing;
        let displayMessage = this.displayMessage;
        processing.show();

        $.ajax({
            url: urlList,
            type: "POST",
            dataType: 'html',
            data: { request: request }
        }).done(function (data) {
            let items = JSON.parse(data);

            if (items.length < batchSize + 1) {
                hideLoadMore();
            }
            else {
                request.LastTicketId = items[batchSize].Id;
                request.LastFinished = items[batchSize].FinishedTicks;
                showLoadMore();
            }

            $.each(items, function (index, item) {
                if (index < batchSize) {
                    let row = table.insertRow(-1);
                    row.insertCell(0).innerHTML = `<a href='${getDetailUrl(urlDetail, item.Id)}'>${item.Id}</a>`;
                    row.insertCell(1).innerHTML = `${item.Status}`;
                    row.insertCell(2).innerHTML = `${item.Handpay}`;
                    row.insertCell(3).innerHTML = `<a href='${getDetailUrl(urlBonusDetail, item.BonusId)}'>${item.BonusName}</a>`;
                    row.insertCell(4).innerHTML = `<a href='${getDetailUrl(urlPlayerDetail, item.PlayerId)}'>${item.PlayerRemoteId}</a>`;
                    row.insertCell(5).innerHTML = `<a href='${getDetailUrl(urlCustomerDetail, item.CustomerId)}'>${item.CustomerName}</a>`;
                    row.insertCell(6).innerHTML = `<a href='${getDetailUrl(urlCustomerOperationDetail, item.CustomerOperationId)}'>${item.CustomerOperationName}</a>`;
                    row.insertCell(7).innerHTML = Utils.isNullOrUndefined(item.PlayerWinAmount) ? '' : `${item.PlayerWinAmount} ${item.PlayerCurrency}`;
                    row.insertCell(8).innerHTML = Utils.isNullOrUndefined(item.MainWinAmount) ? '' : `${item.MainWinAmount} ${item.MainCurrency}`;
                    row.insertCell(9).innerHTML = Utils.isNullOrUndefined(item.LevelCode) ? '' : `${item.LevelCode}`;
                    row.insertCell(10).innerHTML = `${DateUtils.toDefaultWithTime(item.Created)}`;
                    row.insertCell(11).innerHTML = `${DateUtils.toDefaultWithTime(item.Started)}`;
                    row.insertCell(12).innerHTML = `${DateUtils.toDefaultWithTime(item.Finished)}`;
                    row.insertCell(13).innerHTML = Utils.isNullOrUndefined(item.Canceled) ? `${DateUtils.toDefaultWithTime(item.Paid)}` : `${DateUtils.toDefaultWithTime(item.Canceled)}`;
                    row.insertCell(14).innerHTML = Utils.isNullOrUndefined(item.Result) ? '' : `${item.Result}`;
                }
            });

            processing.hide();
            enableRunButton();
        }).fail(function (jqXHR, textStatus, errorThrown) {
            processing.hide();
            enableRunButton();
            displayMessage(jqXHR);
        });
    }

    private getTableBody(): HTMLTableSectionElement {
        return document.getElementById("tableGameRounds").getElementsByTagName("tbody")[0];
    }

    private getDetailUrl(detailUrl: string, data: any): string {
        return `${detailUrl}/${data}`;
    }

    private displayMessage(jqXHR: JQueryXHR): void {
        var statusMessageWrapper = Utils.getJQueryById("statusMessageWrapper");
        let statusMessageData = <StatusMessageModel>{
            code: "500",
            autoClose: false,
            class: "danger",
            message: "Unexpected error",
            type: StatusMessageType.Error
        };
        var statusMessage = new StatusMessage(statusMessageData);
        statusMessageWrapper.html(statusMessage.getHTMLmessage());
        StatusMessageHelper.initValidator();
        StatusMessageHelper.initSatusMessage();
    }

    private run(): void {
        this.disableRunButton();
        let totalEntries = <HTMLSpanElement>this._totalEntries[0];
        totalEntries.innerText = "##";
        this._currentRequest = this.getBrowseRequest();
        let table = this.getTableBody();
        table.innerHTML = "";
        this.sendRequest(this._currentRequest);
    }

    private loadMore(): void {
        this.sendRequest(this._currentRequest);
    }

    private showLoadMoreButton(): void {
        this._loadMoreButton.removeClass("display-none");
    }

    private hideLoadMoreButton(): void {
        this._loadMoreButton.addClass("display-none");
    }

    private disableRunButton(): void {
        this._runButton.attr("disabled", 1);
    }

    private enableRunButton(): void {
        this._runButton.removeAttr("disabled");
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='" + checkboxName + "']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._checkAll[0]).checked;
        }
    }

    private getCountResult() {
        let request = Utils.isNullOrUndefined(this._currentRequest) ? this.getBrowseRequest() : this._currentRequest;
        let urlCount = this._options.urlCount;
        let totalEntries = <HTMLSpanElement>this._totalEntries[0];
        let processing = this._processing;
        let displayMessage = this.displayMessage;
        processing.show();
        $.ajax({
            url: urlCount,
            type: "POST",
            dataType: 'html',
            data: { request: request },
            success: function (data) {
                totalEntries.innerText = data;
                processing.hide();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                processing.hide();
                displayMessage(jqXHR);
            }
        });
    }

    private getBrowseRequest(): ProgressiveBonusBrowseRequest {
        let request = new ProgressiveBonusBrowseRequest();
        request.TicketId = this._filterTicketId.val();
        request.Status = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
        request.Handpay = this._filterHandPay.isAllSelected() ? '' : this._filterHandPay.getSelectionValues(FILTER_DELIM);
        request.Bonus = this._filterBonus.isAllSelected() ? '' : this._filterBonus.getSelectionValues(FILTER_DELIM);
        request.Player = this._filterPlayer.val();
        request.Customer = this._filterCustomer.isAllSelected() ? '' : this._filterCustomer.getSelectionValues(FILTER_DELIM);
        request.CustomerOperation = this._filterCustomerOperation.isAllSelected() ? '' : this._filterCustomerOperation.getSelectionValues(FILTER_DELIM);
        request.LevelWon = this._filterLevelWon.isAllSelected() ? '' : this._filterLevelWon.getSelectionValues(FILTER_DELIM);
        request.CreatedFrom = this._filterCreatedFrom.getUnixTimestamp();
        request.CreatedTo = this._filterCreatedTo.getUnixTimestamp();
        request.StartedFrom = this._filterStartedFrom.getUnixTimestamp();
        request.StartedTo = this._filterStartedTo.getUnixTimestamp();
        request.FinishedFrom = this._filterFinishedFrom.getUnixTimestamp();
        request.FinishedTo = this._filterFinishedTo.getUnixTimestamp();
        request.PaidCanceledFrom = this._filterPaidCanceledFrom.getUnixTimestamp();
        request.PaidCanceledTo = this._filterPaidCanceledTo.getUnixTimestamp();
        request.Result = this._filterResult.isAllSelected() ? '' : this._filterResult.getSelectionValues(FILTER_DELIM);
        request.Source = this._source.val();
        request.BatchSize = batchSize + 1;
        return request;
    }

    private resetFilter(): void {
        this._filterTicketId.val('');
        this._filterPlayer.val('');
        this._filterStatus.selectAll();
        this._filterHandPay.selectAll();
        this._filterBonus.selectAll();
        this._filterCustomer.selectAll();
        this._filterCustomerOperation.selectAll();
        this._filterLevelWon.selectAll();
        this._filterResult.selectAll();
        this._source.val('Live');

        this._filterStartedFrom.clearDates();
        this._filterStartedTo.clearDates();
        this._filterFinishedFrom.clearDates();
        this._filterFinishedTo.clearDates();
        this._filterCreatedFrom.clearDates();
        this._filterCreatedTo.clearDates();
        this._filterPaidCanceledFrom.clearDates();
        this._filterPaidCanceledTo.clearDates();
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ProgressiveBonuses/IndexPage.ts
 **/